package co.torvus.web

import co.torvus.web.components.MobileMenu
import co.torvus.web.components.NavBar
import co.torvus.web.content.navItems
import co.torvus.web.sections.ContactSection
import co.torvus.web.sections.HomeSection
import co.torvus.web.sections.ServicesSection
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLElement
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useRef
import react.useState
import web.cssom.ClassName

val App = FC<Props> {
    var active by useState(navItems.first().id)
    var menuOpen by useState(false)
    val navScrolling = useRef(false)

    val navigate: (String) -> Unit = { id ->
        menuOpen = false
        active = id
        val target = document.getElementById(id) as? HTMLElement
        val root = document.querySelector(".scroll-root")
        if (target != null && root != null) {
            navScrolling.current = true
            smoothScrollTo(root, target.offsetTop.toDouble()) {
                navScrolling.current = false
            }
        }
    }

    NavBar {
        this.active = active
        this.onNavigate = navigate
        this.onOpenMenu = { menuOpen = true }
    }

    div {
        className = ClassName("scroll-root")
        onScroll = {
            if (navScrolling.current != true) {
                val threshold = window.innerHeight * 0.4
                var current = navItems.first().id
                for (item in navItems) {
                    val el = document.getElementById(item.id) ?: continue
                    if (el.getBoundingClientRect().top <= threshold) {
                        current = item.id
                    }
                }
                active = current
            }
        }

        HomeSection {}
        ServicesSection {}
        ContactSection {}
    }

    if (menuOpen) {
        MobileMenu {
            this.active = active
            this.onNavigate = navigate
            this.onClose = { menuOpen = false }
        }
    }
}
